import useTranslate from 'app/i18n/useTranslate';

const useTranslation = () => {
    const t = useTranslate('combobox');

    return {
        ERROR_OCCURRED: t('anErrorHasOccurred')
    };
};

export default useTranslation;
